const REGIONAL_INDICATOR_BASE = 0x1f1e6;
const REGIONAL_INDICATOR_END = 0x1f1ff;
const ASCII_A = 65;
const BLACK_FLAG = 0x1f3f4;
const TAG_BASE = 0xe0000;
const CANCEL_TAG = 0xe007f;

export const flagEmojiToCountryCode = (emoji?: string): string | null => {
  if (!emoji) return null;

  const codePoints = Array.from(emoji).map((char) => char.codePointAt(0) ?? 0);

  const regionalLetters = codePoints
    .filter(
      (cp) => cp >= REGIONAL_INDICATOR_BASE && cp <= REGIONAL_INDICATOR_END
    )
    .map((cp) => String.fromCharCode(cp - REGIONAL_INDICATOR_BASE + ASCII_A));

  if (regionalLetters.length === 2) return regionalLetters.join("");

  if (codePoints[0] === BLACK_FLAG) {
    const tag = codePoints
      .filter((cp) => cp >= TAG_BASE && cp < CANCEL_TAG)
      .map((cp) => String.fromCharCode(cp - TAG_BASE))
      .join("");

    if (tag.length >= 2) return tag.slice(0, 2).toUpperCase();
  }

  return null;
};

export default flagEmojiToCountryCode;
